import http from 'utils/http';
import { getVoiceEnginesUrl, getVoiceEngineUrl, getBusinessVoiceEnginesUrl } from './apiUrls';
import { VoiceEngineResponse, BusinessVoiceEngineResponse } from './types';

export function getVoiceEngines(params?: Record<string, any>): Promise<VoiceEngineResponse> {
  return http.get(getVoiceEnginesUrl(), params);
}

export function updateVoiceEngine(id: number): Promise<void> {
  return http.patch(getVoiceEngineUrl(id));
}

export function getBusinessVoiceEngines(availableVoiceEngineId: number): Promise<BusinessVoiceEngineResponse> {
  return http.get(getBusinessVoiceEnginesUrl(availableVoiceEngineId));
}

export function updateBusinessVoiceEngines(availableVoiceEngineId: number, business_ids: number[]): Promise<void> {
  return http.patch(getBusinessVoiceEnginesUrl(availableVoiceEngineId), { business_ids });
}
